<template>
  <div class="registerSuccess">
    <v-card class="py-8 px-10">
      <h3 class="mb-6 text-center">註冊成功</h3>
      <div class="information">
        <div>恭喜您已成功註冊為我們會員</div>
        <v-icon color="green">fa-check-double</v-icon>
        <div>為了保障您的個人權益</div>
        <div>
          請先進行
          <span class="font-weight-regular">手機</span>
          和
          <span class="font-weight-regular">身分驗證</span>
          以開通完整功能
        </div>
        <v-btn block rounded color="pink" class="mt-4" @click="$router.push('/profile')">進行驗證</v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  created() {
    this.$store.dispatch('user/setToken', `Bearer ${this.$route.query.token}`)
    this.$store.dispatch('user/getUserInformation')
  },
}
</script>

<style lang='scss'>
.registerSuccess {
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .v-card {
    width: 400px;
    .v-icon {
      display: block;
      margin: 20px 0;
      font-size: 70px;
    }
    .information {
      text-align: center;
      & > div {
        font-size: 14px;
      }
    }
  }
}
</style>